import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function AccountDisabledBanner() {
  const { organization } = useAuth();

  if (!organization?.disabled) return null;

  return (
    <output className="block shrink-0 bg-destructive-subtle border-b border-destructive/20 px-4 sm:px-10 py-3 flex items-start gap-3">
      <AlertTriangle size={16} className="text-destructive shrink-0 mt-0.5" />
      <div className="text-[0.8125rem] leading-snug">
        <span className="text-destructive font-medium">Cuenta desactivada.</span>{' '}
        <span className="text-ink-secondary">
          Puedes consultar tus procesos, pero no crear ni modificar búsquedas. Escríbenos a{' '}
          <a
            href="mailto:soporte@legalhermes.com"
            className="text-ink underline underline-offset-2 hover:text-accent"
          >
            soporte@legalhermes.com
          </a>{' '}
          para reactivarla.
        </span>
      </div>
    </output>
  );
}
